module.exports = __webpack_public_path__ + "img/1490067713.1fd3dfa8.jpg";